/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Uniqueworkplace_Multilingual1Inputs */

const ja_careers_uniqueworkplace_multilingual1 = /** @type {(inputs: Careers_Uniqueworkplace_Multilingual1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多言語・多文化のチーム`)
};

const en_careers_uniqueworkplace_multilingual1 = /** @type {(inputs: Careers_Uniqueworkplace_Multilingual1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multilingual and multicultural team`)
};

/**
* | output |
* | --- |
* | "Multilingual and multicultural team" |
*
* @param {Careers_Uniqueworkplace_Multilingual1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_uniqueworkplace_multilingual1 = /** @type {((inputs?: Careers_Uniqueworkplace_Multilingual1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Uniqueworkplace_Multilingual1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_uniqueworkplace_multilingual1(inputs)
	return en_careers_uniqueworkplace_multilingual1(inputs)
});
export { careers_uniqueworkplace_multilingual1 as "careers_uniqueWorkplace_multilingual" }